export default __webpack_public_path__ + "static/media/ID_LIV_OCTOCAT Kawai.9f4cc18b.jpg";